import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DialogConfig } from '../dialog/dialog-config';
import { DialogRef } from '../dialog/dialog-ref';
import { DialogService } from '../dialog/dialog.service';
import { LoaderService } from '../../services/loader.service';
import { BaseService } from '../../shared/services/base.service';
import { CommunicationService } from '../../services/communication.service';
import { AlertsService } from '../../services/alerts.service';

@Component({
    selector: 'app-dropdown-object',
    templateUrl: './dropdown-object.component.html',
    styleUrls: ['./dropdown-object.component.scss'],
    standalone: false
})
export class DropdownObjectComponent implements OnInit {

  fields: any = [];
  cancelRoute: string;
  delegateSave: boolean;
  objectForm: FormGroup;
  objData: any;
  action:string = 'ADD';
  resource: string;
  activatedResource: string;
  configForm: any;
  
  constructor(
    public config: DialogConfig,
    public dialog: DialogRef,
    public dialogService: DialogService,
    public loaderService: LoaderService,
    public baseService: BaseService,
    public communicationService: CommunicationService,
    public alertService: AlertsService
  ) { }

  ngOnInit() {
    this.configForm = {
      "submitButton" : true,
      "cancelButton" : true,
      "filterForm" : false,
      "clearOnSave": true,
      "delegateSave": true,
      "cancelRoute": ''
    }
    let receiveddata: any = this.config.data;
    this.resource = receiveddata.resource;
    this.fields = receiveddata.formblocks;
  }


  saveFinished(event) {
    this.saveData(event);
  }

  saveData(event) {
    this.loaderService.showSpinner();
    delete event.result.id;
    this.baseService.action(event.result, this.action, null, this.resource).subscribe(
      (data: any) => {
        this.communicationService.emitChange({ completed: true });
        if (data.errCode == -1) {
          this.alertService.error(data.message);
        } else {
          this.alertService.success("Added Successfully");
        }
        this.dialog.close(data.resource[0]);
        this.loaderService.hideSpinner();
      }, error => {
        console.log(error);
        this.alertService.error('API error');
        this.loaderService.hideSpinner();
      }
    )
  }

}
